module.exports = __webpack_public_path__ + "5e70e0ff876ea7344332b0a4e2dbe5d0.png";